/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_History_HeadingInputs */

const tr_geliver_tracking_history_heading = /** @type {(inputs: Geliver_Tracking_History_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Takip Bilgisi`)
};

const en_geliver_tracking_history_heading = /** @type {(inputs: Geliver_Tracking_History_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Tracking Info`)
};

const de_geliver_tracking_history_heading = /** @type {(inputs: Geliver_Tracking_History_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Tracking-Info`)
};

const ru_geliver_tracking_history_heading = /** @type {(inputs: Geliver_Tracking_History_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последняя информация`)
};

/**
* | output |
* | --- |
* | "Latest Tracking Info" |
*
* @param {Geliver_Tracking_History_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_history_heading = /** @type {((inputs?: Geliver_Tracking_History_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_History_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_history_heading(inputs)
	if (locale === "de") return de_geliver_tracking_history_heading(inputs)
	if (locale === "ru") return ru_geliver_tracking_history_heading(inputs)
	return tr_geliver_tracking_history_heading(inputs)
});